var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMainInformationIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.084,
  cy: 20,
  fill: "#FFF09F",
  rx: 20.045,
  ry: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20 9C13.936 9 9 13.936 9 20s4.936 11 11 11 11-4.936 11-11S26.064 9 20 9m0 3.438a4.13 4.13 0 0 1 4.125 4.124A4.13 4.13 0 0 1 20 20.688a4.13 4.13 0 0 1-4.125-4.125A4.13 4.13 0 0 1 20 12.438m7.267 12.746A8.93 8.93 0 0 1 20 28.937a8.93 8.93 0 0 1-7.267-3.753.69.69 0 0 1 .076-.894A10.29 10.29 0 0 1 20 21.375c1.698 0 3.376.42 4.847 1.21.86.454 1.65 1.031 2.344 1.712a.68.68 0 0 1 .076.887"
})));
export default SvgMainInformationIco;